exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reqHdrTr{height:43px;}\r\n.reqHdrTr th{background-color: #b2cedf;color:white;border-color:white!important;text-align:right;}\r\n.table-bordered{border-color:#3d759a!important;}\r\n.table-bordered>tbody>tr>td{border-color:#3d759a!important;}\r\n.table-striped>tbody>tr:nth-of-type(odd){background-color:#e4f1f9!important;}\r\n.table-striped>tbody>tr:nth-of-type(even){background-color:#fff!important;}\r\n.table tbody tr{cursor:auto;}\r\n.requirements tbody tr{height:32px;}\r\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n     /* IE10+ CSS styles go here */\r\n     table.requirements{table-layout:fixed;}\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/req.css
// module id = 296
// module chunks = 1